export class QuestionChoice {
    ChoiceId: number;
    ChoiceKey: string;
    NextQuestionId: number;
    HasInfoPopup: boolean;
    InfoPopupKey: string;
}

export class Answer {
    ChoiceId: number;
    Answerkey: string;
    AnswerText: string;
    AnsweredDateTime: string;
}

export class Question {
    QuestionId: number;
    QuestionOrder: number;
    QuestionText?: any;
    QuestionKey: string;
    QuestionType: string;
    Datatype: string;
    Mandatory: boolean;
    Maxlength: number;
    ChoiceUIType: string;
    Language?: any;
    QuestionChoices: QuestionChoice[];
    Answers: Answer[];
}

export class QuestionGroup {
    QuestionGroupID: number;
    GroupOrder: number;
    GroupKey: string;
    Questions: Question[];
}

export class SectionObject {
    SectionKey: string;
    SectionID: number;
    SectionOrder: number;
    QuestionGroup: QuestionGroup[];
}
